<script>
	import { onDestroy, getContext } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { url } from '../library/scripts/Setup.svelte'
	import {
		storeElementID,
		storeData,
		storeShowTools,
		storeBuilderPreview,
		storeSite,
		storeUpdateSingle,
		storeIsLinked,
		storeActiveBlock,
	} from '../library/scripts/Store.svelte'
	import IntersectionObserver from 'svelte-intersection-observer'

	export let blockName = null
	export let linkedSite = false

	// create the blockID from blockName
	let blockID = blockName.split(' ')
	blockID = blockID[0] + '_' + blockID[1]

	const globals = getContext('globals')
	const colorError = globals.colorError
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const devWidth = globals.devWidth
	const isMobi = globals.mobi
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover
	//the folder from which to take images
	let folder

	// desktop & notebook
	if (!isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/medium/'
	}

	let configFile
	let showTools
	let showPreview
	let gridGap

	// the linked pages
	let linked1 = false
	let linked2 = false
	let linked3 = false
	let linked4 = false

	// array to hold all linked pages (used to show linked pages in tool bar of block)
	let linkArr = []

	let userName

	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value
			userName = value.username

			configFile.blocks.forEach((block) => {
				if (block.blockName === blockName) {
					if (block.content.length === 2) folder = '/medium/'
					if (block.content.length > 2) folder = '/small/'
					gridGap = block.blockGridGap + '%'
					block.content.forEach((content) => {
						if (content.id === 1 && content.link) {
							linked1 = content.link
							linkArr.push(linked1)
						}
						if (content.id === 2 && content.link) {
							linked2 = content.link
							linkArr.push(linked2)
						}
						if (content.id === 3 && content.link) {
							linked3 = content.link
							linkArr.push(linked3)
						}
						if (content.id === 4 && content.link) {
							linked4 = content.link
							linkArr.push(linked4)
						}
					})
				}
			})
		}
	})

	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	let elementID = null

	let cursor = 'default'

	// redirect to create block if its a linked site
	const re_direct = (l, b) => {
		storeUpdateSingle.set(b)
		if (l) storeIsLinked.set(true)
		storeActiveBlock.set(b)
		document.location = '#/createblock'
	}

	// open the link if column is a link
	const open_link = (n, i, l) => {
		const linkedObject = { name: n, id: i, link: l }
		storeActiveBlock.set(n)
		storeSite.set(linkedObject)
		// redirect to the correct location
		if (l.indexOf('http') > -1) {
			window.open(l)
			return
		}

		if (l.indexOf('#/') > -1) {
			document.location = l
			return
		}

		document.location = '#/linksite'
	}

	const set_elementID = (e) => {
		if (linkedSite) return
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	//observer
	let element
	let large = false
	const set_observer = (e) => {
		if (e === 'set') {
			large = false
			element.style.filter = 'blur(5px)'
		} else {
			large = true
			element.style.filter = 'blur(0px)'
		}
	}

	onDestroy(() => {
		stoData
		stoShowTools
		stoPreview
		storeShowTools.set(false)
	})
</script>

<IntersectionObserver
	{element}
	threshold="0.3"
	on:observe={(e) => {
		if (!e.detail.isIntersecting) {
			set_observer('set')
		} else {
			set_observer('unset')
		}
	}}
>
	{#if configFile}
		{#each configFile.blocks as block}
			{#if block.blockName === blockName && blockName !== 'mail'}
				{#if !showPreview}
					<div
						class="content_row"
						use:styles={{ fsS, builderToolbar, builderToolbarHover }}
						on:click={() => set_elementID(block.blockName)}
						on:keydown={() => set_elementID(block.blockName)}
					>
						{#if !linkedSite}
							<div style="margin-left:20px;text-transform:uppercase;">*OPEN {block.blockName} TOOL*</div>
						{/if}

						{#if linkedSite}
							<div class="linked_site" use:styles={{ colorError, fsN }}>*{block.blockName} Linked Site*</div>
						{/if}
						{#if linkArr.length > 0 && !linkedSite}
							<div class="link_row" use:styles={{ fsXS }}>
								<div class="link_title">linked sites</div>
								{#each block.content as content}
									{#if content.link}
										<div
											class="link"
											on:click={() => re_direct(true, content.link)}
											on:keydown={() => re_direct(true, content.link)}
										>
											col {content.id} - {content.link}
										</div>
									{/if}
								{/each}
							</div>
						{/if}
					</div>
				{/if}
				{#if linkedSite}
					{#if block.isLinked}
						<div class="link_row" data-link data-padding use:styles={{ fsXS }}>
							linked to:
							{#each configFile.blocks as b}
								{#if b.content}
									{#each b.content as bc}
										{#if bc.link && bc.link !== 'select' && bc.link === block.blockName}
											<div
												class="link"
												on:click={() => re_direct(false, b.blockName)}
												on:keydown={() => re_direct(false, b.blockName)}
											>
												{b.blockName} column {bc.id}
											</div>
										{/if}
									{/each}
								{/if}
							{/each}
						</div>
					{/if}
				{/if}
				{#if !linkedSite}
					<div
						id={blockID}
						bind:this={element}
						style="
						display:flex;
						flex-direction:column;
						padding:{block.padding}%;
						margin-top:{block.marginTop}%;
						margin-bottom:{block.marginBottom}%;
						border-top-left-radius : {block.borderTopRadius}px;
						border-top-right-radius : {block.borderTopRadius}px;
						border-bottom-left-radius: {block.borderBottomRadius}px;
						border-bottom-right-radius: {block.borderBottomRadius}px;
						border-left-width:{block.borderLeftWidth}px;
						border-left-style:{block.borderLeftStyle};
						border-left-color:{block.borderLeftColor};
						border-top-width:{block.borderTopWidth}px;
						border-top-style:{block.borderTopStyle};
						border-top-color:{block.borderTopColor};
						border-right-width:{block.borderRightWidth}px;
						border-right-style:{block.borderRightStyle};
						border-right-color:{block.borderRightColor};
						border-bottom-width:{block.borderBottomWidth}px;
						border-bottom-style: {block.borderBottomStyle};
						border-bottom-color:{block.borderBottomColor};
						background-color:{block.backgroundColor};
						background-image: {block.backgroundImage});
						background-size:{block.backgroundSize};
						background-repeat:{block.backgroundRepeat};
						box-shadow: 0px {block.blockBoxShadowY}px {block.blockBoxShadowBlur}px {block.blockBoxShadowColor};
						"
					>
						{#if block.blockTitle}
							{#if !showPreview}
								<div
									class="content_row"
									use:styles={{ fsS, builderToolbar, builderToolbarHover }}
									on:click={() => set_elementID(block.blockName + '_blockTitle')}
									on:keydown={() => set_elementID(block.blockName + '_blockTitle')}
								>
									<div style="margin-left:20px;text-transform:uppercase;">*OPEN {block.blockName} TITLE TOOL*</div>
								</div>
							{/if}

							<div
								id={block.blockName + '_blockTitle'}
								style="
								display:flex;
								width:{block.blockTitleWidth}%;
								min-height: {block.blockTitleHeight}px;
								justify-content:{block.blockTitleAlignHorizontal};
								align-items:{block.blockTitleAlignVertical};
								color:{block.blockTitleFontColor};
								background-color:{block.blockTitleBackgroundColor};
								font-family:{block.blockTitleFontFamily};
								font-size:{block.blockTitleFontSize};
								font-weight: {block.blockTitleFontWeight};
								font-style:{block.blockTitleFontStyle};
								text-decoration:{block.blockTitleFontDeco};
								margin-top:{block.blockTitleMarginTop}%;
								margin-bottom:{block.blockTitleMarginBottom}%;
								padding:{block.blockTitlePadding}%;
								cursor: {cursor};
								text-shadow: {block.blockTitleShadowOffsetX}px {block.blockTitleShadowOffsetY}px {block.blockTitleShadowBlur}px {block.blockTitleShadowColor};
								"
							>
								{block.blockTitle}
							</div>
						{/if}
						<div class="column_row" use:styles={{ gridGap }}>
							{#each Object.entries(block.content) as [key, content], index (key)}
								<div class="column_container">
									{#if !showPreview}
										<div class="column_tool_bar_container">
											{#if block.content.length > 0}
												<div
													on:click={() => set_elementID(block.blockName + '_column_' + index)}
													on:keydown={() => set_elementID(block.blockName + '_column_' + index)}
												>
													<div class="column_tool_link" use:styles={{ fsN }}>Column</div>
												</div>
											{/if}
											{#if block.content[index].title}
												<div
													on:click={() => set_elementID(block.blockName + '_title_' + index)}
													on:keydown={() => set_elementID(block.blockName + '_title_' + index)}
												>
													<div class="column_tool_link" use:styles={{ fsN }}>Title</div>
												</div>
											{/if}
											{#if block.content[index].image}
												<div
													on:click={() => set_elementID(block.blockName + '_image_' + index)}
													on:keydown={() => set_elementID(block.blockName + '_image_' + index)}
												>
													<div class="column_tool_link" use:styles={{ fsN }}>Image</div>
												</div>
											{/if}
											{#if block.content[index].text}
												<div
													on:click={() => set_elementID(block.blockName + '_text_' + index)}
													on:keydown={() => set_elementID(block.blockName + '_text_' + index)}
												>
													<div class="column_tool_link" use:styles={{ fsN }}>Text</div>
												</div>
											{/if}
										</div>
									{/if}

									{#if !block.content[key].backgroundImage}
										<div
											id={block.blockName + '_column_' + index}
											style="
											position:relative;
											width: 100%;
											height:100%;
											padding : {block.content[index].padding}%;
											margin-top: {block.content[index].marginTop}%;
											margin-bottom: {block.content[index].marginBottom}%;
											background-color : {block.content[index].backgroundColor};
											border-top-left-radius : {block.content[index].borderTopRadius}px;
											border-top-right-radius : {block.content[index].borderTopRadius}px;
											border-bottom-left-radius: {block.content[index].borderBottomRadius}px;
											border-bottom-right-radius: {block.content[index].borderBottomRadius}px;
											border-background-image : {block.content[index].borderBackgroundImage};
											border-left-width : {block.content[index].borderLeftWidth}px;
											border-left-style : {block.content[index].borderLeftStyle};
											border-left-color : {block.content[index].borderLeftColor};
											border-top-width : {block.content[index].borderTopWidth}px;
											border-top-style : {block.content[index].borderTopStyle};
											border-top-color : {block.content[index].borderTopColor};
											border-right-width : {block.content[index].borderRightWidth}px;
											border-right-style : {block.content[index].borderRightStyle};
											border-right-color : {block.content[index].borderRightColor};
											border-bottom-width : {block.content[index].borderBottomWidth}px;
											border-bottom-style : {block.content[index].borderBottomStyle};
											border-bottom-color : {block.content[index].borderBottomColor};
											background-image : {block.content[index].backgroundImage};
											background-size:{block.content[index].backgroundSize};
											background-repeat:{block.content[index].backgroundRepeat};
											box-shadow: {block.content[index].columnBoxShadowX}px {block.content[index].columnBoxShadowY}px {block.content[index]
												.columnBoxShadowBlur}px {block.content[index].columnBoxShadowColor};
											cursor: {cursor};
										"
										>
											{#if block.content[key].title && !block.content[key].link}
												<div
													id={block.blockName + '_title_' + index}
													style="
														position:absolute;
														top:{block.content[index].titlePosTop}%;
														left: {block.content[index].titlePosLeft}%;
														display:flex;
														width:{block.content[index].titleWidth}%;
														min-height: {block.content[index].titleHeight}px;
														justify-content: {block.content[index].titleAlignHorizontal};
														align-items: {block.content[index].titleAlignVertical};
														font-family : {block.content[index].titleFontFamily};
														font-size : {block.content[index].titleFontSize};
														color : {block.content[index].titleFontColor};
														font-weight : {block.content[index].titleFontWeight};
														font-style : {block.content[index].titleFontStyle};
														text-decoration: {block.content[index].titleFontDeco};
														background-color : {block.content[index].titleBackgroundColor};
														margin-top : {block.content[index].titleMarginTop}%;
														margin-bottom : {block.content[index].titleMarginBottom}%;
														padding : {block.content[index].titlePadding}%;
														text-shadow: {block.content[index].titleColumnShadowOffsetX}px {block.content[index].titleColumnShadowOffsetY}px {block
														.content[index].titleColumnShadowBlur}px {block.content[index].titleColumnShadowColor};

														border-top-left-radius : {block.content[index].borderTopRadius}px;
														border-top-right-radius : {block.content[index].borderTopRadius}px;
														border-bottom-left-radius: {block.content[index].borderBottomRadius}px;
														border-bottom-right-radius: {block.content[index].borderBottomRadius}px;
													"
												>
													{block.content[key].title}
												</div>
											{/if}

											{#if block.content[key].title && block.content[key].link}
												<article
													id={block.blockName + '_title_' + index}
													on:click={() => open_link(block.blockName, block.content[key].id, block.content[key].link)}
													on:keydown={() => open_link(block.blockName, block.content[key].id, block.content[key].link)}
													style="
														--linkColor:{block.content[index].titleFontColor};
														--linkHover: {block.content[index].linkHover};
														position:absolute;
														top:{block.content[index].titlePosTop}%;
														display:flex;
														width:{block.content[index].titleWidth}%;
														min-height: {block.content[index].titleHeight}px;
														justify-content: {block.content[index].titleAlignHorizontal};
														align-items: {block.content[index].titleAlignVertical};
														font-family : {block.content[index].titleFontFamily};
														font-size : {block.content[index].titleFontSize};
														font-weight : {block.content[index].titleFontWeight};
														font-style : {block.content[index].titleFontStyle};
														text-decoration: {block.content[index].titleFontDeco};
														background-color : {block.content[index].titleBackgroundColor};
														margin-top : {block.content[index].titleMarginTop}%;
														margin-bottom : {block.content[index].titleMarginBottom}%;
														padding : {block.content[index].titlePadding}%;
														text-shadow: {block.content[index].titleColumnShadowOffsetX}px {block.content[index].titleColumnShadowOffsetY}px {block
														.content[index].titleColumnShadowBlur}px {block.content[index].titleColumnShadowColor};

														border-top-left-radius : {block.content[index].borderTopRadius}px;
														border-top-right-radius : {block.content[index].borderTopRadius}px;
														border-bottom-left-radius: {block.content[index].borderBottomRadius}px;
														border-bottom-right-radius: {block.content[index].borderBottomRadius}px;
														cursor:pointer;
													"
												>
													{block.content[key].title}
												</article>
											{/if}

											{#if block.content[key].image && !block.content[key].link}
												<div
													class="image_container"
													id="imgcontainer"
													style="
													margin-top:{block.content[index].imageMarginTop}%;
													margin-bottom:{block.content[index].imageMarginBottom}%;
													padding: {block.content[index].imagePadding}%;
													"
												>
													<div
														id={block.blockName + '_imageContainer_' + index}
														style="
														width:{block.content[index].imageWidth}%;
													
														"
													>
														{#if !block.content[key].backgroundImage && large}
															<img
																id={block.blockName + '_image_' + block.content[index].image}
																class="col_image"
																style="
																	box-shadow: {block.content[index].boxShadowX}px {block.content[index].boxShadowY}px {block.content[index]
																	.boxShadowBlur}px {block.content[index].boxShadowColor};

																	border-left: {block.content[index].imageBorderLeftWidth}px {block.content[index].imageBorderLeftStyle} {block.content[
																	index
																].imageBorderLeftColor};

																	border-top: {block.content[index].imageBorderTopWidth}px {block.content[index].imageBorderTopStyle} {block.content[
																	index
																].imageBorderTopColor};

																	border-right: {block.content[index].imageBorderRightWidth}px {block.content[index].imageBorderRightStyle} {block
																	.content[index].imageBorderRightColor};

																	border-bottom: {block.content[index].imageBorderBottomWidth}px {block.content[index].imageBorderBottomStyle} {block
																	.content[index].imageBorderBottomColor};

																	border-top-left-radius : {block.content[index].imageBorderTopRadius}px;
																	border-top-right-radius : {block.content[index].imageBorderTopRadius}px;
																	border-bottom-left-radius: {block.content[index].imageBorderBottomRadius}px;
																	border-bottom-right-radius: {block.content[index].imageBorderBottomRadius}px;
																	"
																src={url + '/' + block.blockName + folder + block.content[index].image}
																alt="col_img"
															/>
														{/if}

														{#if !block.content[key].backgroundImage && !large}
															<img
																id={block.blockName + '_image_' + block.content[index].image}
																class="col_image"
																style="
																	box-shadow: {block.content[index].boxShadowX}px {block.content[index].boxShadowY}px {block.content[index]
																	.boxShadowBlur}px {block.content[index].boxShadowColor};

																	border-left: {block.content[index].imageBorderLeftWidth}px {block.content[index].imageBorderLeftStyle} {block.content[
																	index
																].imageBorderLeftColor};

																	border-top: {block.content[index].imageBorderTopWidth}px {block.content[index].imageBorderTopStyle} {block.content[
																	index
																].imageBorderTopColor};

																	border-right: {block.content[index].imageBorderRightWidth}px {block.content[index].imageBorderRightStyle} {block
																	.content[index].imageBorderRightColor};

																	border-bottom: {block.content[index].imageBorderBottomWidth}px {block.content[index].imageBorderBottomStyle} {block
																	.content[index].imageBorderBottomColor};

																	border-top-left-radius : {block.content[index].imageBorderTopRadius}px;
																	border-top-right-radius : {block.content[index].imageBorderTopRadius}px;
																	border-bottom-left-radius: {block.content[index].imageBorderBottomRadius}px;
																	border-bottom-right-radius: {block.content[index].imageBorderBottomRadius}px;
																	"
																src={url + '/' + block.blockName + folder + block.content[index].image}
																alt="col_img"
															/>
														{/if}
													</div>
												</div>
											{/if}

											{#if block.content[key].image && block.content[key].link}
												<div
													on:click={() => open_link(block.blockName, block.content[key].id, block.content[key].link)}
													on:keydown={() => open_link(block.blockName, block.content[key].id, block.content[key].link)}
													class="image_container"
													data-imagehover
													id="imgcontainer"
													style="
													margin-top:{block.content[index].imageMarginTop}%;
													margin-bottom:{block.content[index].imageMarginBottom}%;
													padding: {block.content[index].imagePadding}%;
													cursor:pointer;
													"
												>
													<div
														id={block.blockName + '_imageContainer_' + index}
														style="
														width:{block.content[index].imageWidth}%;
													"
													>
														{#if !block.content[key].backgroundImage && large}
															<img
																id={block.blockName + '_image_' + block.content[index].image}
																class="col_image"
																style="
																	box-shadow: {block.content[index].boxShadowX}px {block.content[index].boxShadowY}px {block.content[index]
																	.boxShadowBlur}px {block.content[index].boxShadowColor};

																	border-left: {block.content[index].imageBorderLeftWidth}px {block.content[index].imageBorderLeftStyle} {block.content[
																	index
																].imageBorderLeftColor};

																	border-top: {block.content[index].imageBorderTopWidth}px {block.content[index].imageBorderTopStyle} {block.content[
																	index
																].imageBorderTopColor};

																	border-right: {block.content[index].imageBorderRightWidth}px {block.content[index].imageBorderRightStyle} {block
																	.content[index].imageBorderRightColor};

																	border-bottom: {block.content[index].imageBorderBottomWidth}px {block.content[index].imageBorderBottomStyle} {block
																	.content[index].imageBorderBottomColor};

																	border-top-left-radius : {block.content[index].imageBorderTopRadius}px;
																	border-top-right-radius : {block.content[index].imageBorderTopRadius}px;
																	border-bottom-left-radius: {block.content[index].imageBorderBottomRadius}px;
																	border-bottom-right-radius: {block.content[index].imageBorderBottomRadius}px;
																	"
																src={url + '/' + block.blockName + folder + block.content[index].image}
																alt="col_img"
															/>
														{/if}

														{#if !block.content[key].backgroundImage && !large}
															<img
																id={block.blockName + '_image_' + block.content[index].image}
																class="col_image"
																style="
																	box-shadow: {block.content[index].boxShadowX}px {block.content[index].boxShadowY}px {block.content[index]
																	.boxShadowBlur}px {block.content[index].boxShadowColor};

																	border-left: {block.content[index].imageBorderLeftWidth}px {block.content[index].imageBorderLeftStyle} {block.content[
																	index
																].imageBorderLeftColor};

																	border-top: {block.content[index].imageBorderTopWidth}px {block.content[index].imageBorderTopStyle} {block.content[
																	index
																].imageBorderTopColor};

																	border-right: {block.content[index].imageBorderRightWidth}px {block.content[index].imageBorderRightStyle} {block
																	.content[index].imageBorderRightColor};

																	border-bottom: {block.content[index].imageBorderBottomWidth}px {block.content[index].imageBorderBottomStyle} {block
																	.content[index].imageBorderBottomColor};

																	border-top-left-radius : {block.content[index].imageBorderTopRadius}px;
																	border-top-right-radius : {block.content[index].imageBorderTopRadius}px;
																	border-bottom-left-radius: {block.content[index].imageBorderBottomRadius}px;
																	border-bottom-right-radius: {block.content[index].imageBorderBottomRadius}px;
																"
																src={url + '/' + block.blockName + folder + block.content[index].image}
																alt="col_img"
															/>
														{/if}
													</div>
												</div>
											{/if}

											{#if block.content[key].text && !block.content[key].link}
												{#if block.content[key].image}
													<div
														id={block.blockName + '_text_' + index}
														style="
														display:flex;
														position:absolute;
														top:{block.content[index].textPosTop}%;
														left:{block.content[index].textPosLeft}%;
														width:{block.content[index].textWidth}%;
														min-height: {block.content[index].textHeight}%;
														justify-content: {block.content[index].textAlignHorizontal};
														align-items: {block.content[index].textAlignVertical};
														font-family : {block.content[index].textFontFamily};
														font-size : {block.content[index].textFontSize};
														color : {block.content[index].textFontColor};
														font-weight : {block.content[index].textFontWeight};
														font-style : {block.content[index].textFontStyle};
														text-decoration: {block.content[index].textFontDeco};
														text-align: {block.content[index].textAlign};
														background-color : {block.content[index].textBackgroundColor};
														margin-top : {block.content[index].textMarginTop}%;
														margin-bottom : {block.content[index].textMarginBottom}%;
														padding : {block.content[index].textPadding}%;
														user-select: text;
														white-space:pre-wrap;
														"
													>
														{block.content[key].text}
													</div>
												{/if}

												{#if !block.content[key].image}
													<div
														id={block.blockName + '_text_' + index}
														style="
														display:flex;
														width:{block.content[index].textWidth}%;
														min-height: {block.content[index].textHeight}px;
														justify-content: {block.content[index].textAlignHorizontal};
														align-items: {block.content[index].textAlignVertical};
														font-family : {block.content[index].textFontFamily};
														font-size : {block.content[index].textFontSize};
														color : {block.content[index].textFontColor};
														font-weight : {block.content[index].textFontWeight};
														font-style : {block.content[index].textFontStyle};
														text-decoration: {block.content[index].textFontDeco};
														text-align: {block.content[index].textAlign};
														background-color : {block.content[index].textBackgroundColor};
														margin-top : {block.content[index].textMarginTop}%;
														margin-bottom : {block.content[index].textMarginBottom}%;
														padding : {block.content[index].textPadding}%;
														user-select: text;
														white-space:pre-wrap;
														"
													>
														{block.content[key].text}
													</div>
												{/if}
											{/if}

											{#if block.content[key].text && block.content[key].link}
												{#if block.content[key].image}
													<article
														on:click={() => open_link(block.blockName, block.content[key].id, block.content[key].link)}
														on:keydown={() =>
															open_link(block.blockName, block.content[key].id, block.content[key].link)}
														id={block.blockName + '_text_' + index}
														style="
														--linkColor:{block.content[index].textFontColor};
														--linkHover: {block.content[index].linkHover};
														display:flex;
														position:absolute;
														top:{block.content[index].textPosTop}%;
														left:{block.content[index].textPosLeft}%;
														width:{block.content[index].textWidth}%;
														min-height: {block.content[index].textHeight}%;
														justify-content: {block.content[index].textAlignHorizontal};
														align-items: {block.content[index].textAlignVertical};
														font-family : {block.content[index].textFontFamily};
														font-size : {block.content[index].textFontSize};
														font-weight : {block.content[index].textFontWeight};
														font-style : {block.content[index].textFontStyle};
														text-decoration: {block.content[index].textFontDeco};
														text-align: {block.content[index].textAlign};
														background-color : {block.content[index].textBackgroundColor};
														margin-top : {block.content[index].textMarginTop}%;
														margin-bottom : {block.content[index].textMarginBottom}%;
														padding : {block.content[index].textPadding}%;
														user-select: text;
														white-space:pre-wrap;
														cursor:pointer;
														"
													>
														{block.content[key].text}
													</article>
												{/if}

												{#if !block.content[key].image}
													<article
														on:click={() => open_link(block.blockName, block.content[key].id, block.content[key].link)}
														on:keydown={() =>
															open_link(block.blockName, block.content[key].id, block.content[key].link)}
														id={block.blockName + '_text_' + index}
														style="
														--linkColor:{block.content[index].textFontColor};
														--linkHover: {block.content[index].linkHover};
														display:flex;
														width:{block.content[index].textWidth}%;
														min-height: {block.content[index].textHeight}px;
														justify-content: {block.content[index].textAlignHorizontal};
														align-items: {block.content[index].textAlignVertical};
														font-family : {block.content[index].textFontFamily};
														font-size : {block.content[index].textFontSize};
														font-weight : {block.content[index].textFontWeight};
														font-style : {block.content[index].textFontStyle};
														text-decoration: {block.content[index].textFontDeco};
														text-align: {block.content[index].textAlign};
														background-color : {block.content[index].textBackgroundColor};
														margin-top : {block.content[index].textMarginTop}%;
														margin-bottom : {block.content[index].textMarginBottom}%;
														padding : {block.content[index].textPadding}%;
														user-select: text;
														white-space:pre-wrap;
														cursor:pointer;
														"
													>
														{block.content[key].text}
													</article>
												{/if}
											{/if}
										</div>
									{:else if block.content[key].backgroundImage}
										<div
											id={block.blockName + '_column_' + index}
											style="
											position:relative;
											width: 100%;
											height:100%;
											padding : {block.content[index].padding}%;
											margin-top: {block.content[index].marginTop}%;
											margin-bottom: {block.content[index].marginBottom}%;
											background-color : {block.content[index].backgroundColor};
											border-top-left-radius : {block.content[index].borderTopRadius}px;
											border-top-right-radius : {block.content[index].borderTopRadius}px;
											border-bottom-left-radius: {block.content[index].borderBottomRadius}px;
											border-bottom-right-radius: {block.content[index].borderBottomRadius}px;
											border-background-image : {block.content[index].borderBackgroundImage};
											border-left-width : {block.content[index].borderLeftWidth}px;
											border-left-style : {block.content[index].borderLeftStyle};
											border-left-color : {block.content[index].borderLeftColor};
											border-top-width : {block.content[index].borderTopWidth}px;
											border-top-style : {block.content[index].borderTopStyle};
											border-top-color : {block.content[index].borderTopColor};
											border-right-width : {block.content[index].borderRightWidth}px;
											border-right-style : {block.content[index].borderRightStyle};
											border-right-color : {block.content[index].borderRightColor};
											border-bottom-width : {block.content[index].borderBottomWidth}px;
											border-bottom-style : {block.content[index].borderBottomStyle};
											border-bottom-color : {block.content[index].borderBottomColor};
											background-size:{block.content[index].backgroundSize};
											background-repeat:{block.content[index].backgroundRepeat};
											box-shadow: {block.content[index].columnBoxShadowX}px {block.content[index].columnBoxShadowY}px {block.content[index]
												.columnBoxShadowBlur}px {block.content[index].columnBoxShadowColor};
											cursor: {cursor};
											background-image:url('{url}/{block.blockName}{folder}{block.content[index].backgroundImage}');
											background-size:{block.content[index].objectFit};
											"
										>
											{#if block.content[key].title}
												<div
													id={block.blockName + '_title_' + index}
													style="
													position:absolute;
													top:{block.content[index].titlePosTop}%;
													display:flex;
													width:{block.content[index].titleWidth}%;
													min-height: {block.content[index].titleHeight}px;
													justify-content: {block.content[index].titleAlignHorizontal};
													align-items: {block.content[index].titleAlignVertical};
													font-family : {block.content[index].titleFontFamily};
													font-size : {block.content[index].titleFontSize};
													color : {block.content[index].titleFontColor};
													font-weight : {block.content[index].titleFontWeight};
													font-style : {block.content[index].titleFontStyle};
													text-decoration: {block.content[index].titleFontDeco};
													background-color : {block.content[index].titleBackgroundColor};
													margin-top : {block.content[index].titleMarginTop}%;
													margin-bottom : {block.content[index].titleMarginBottom}%;
													padding : {block.content[index].titlePadding}%;
													border-top-left-radius:{block.content[index].titleColumnBorderRadius}px;
													border-top-right-radius: {block.content[index].titleColumnBorderRadius}px;
													"
												>
													{block.content[key].title}
												</div>
											{/if}

											{#if block.content[key].image}
												<div
													class="image_container"
													id="imgcontainer"
													style="
													margin-top:{block.content[index].imageMarginTop}%;
													margin-bottom:{block.content[index].imageMarginBottom}%;
													padding: {block.content[index].imagePadding}%;
													"
												>
													<div
														id={block.blockName + '_imageContainer_' + index}
														style="
														width:{block.content[index].imageWidth}%;
														"
													/>
												</div>
											{/if}

											{#if block.content[key].text}
												<div
													id={block.blockName + '_text_' + index}
													style="
													display:flex;
													width:{block.content[index].textWidth}%;
													min-height: {block.content[index].textHeight}%;
													justify-content: {block.content[index].textAlignHorizontal};
													top: {block.content[index].textPosTop}%;
													left:{block.content[index].textPosLeft}%;
													align-items: {block.content[index].textAlignVertical};
													font-family : {block.content[index].textFontFamily};
													font-size : {block.content[index].textFontSize};
													color : {block.content[index].textFontColor};
													font-weight : {block.content[index].textFontWeight};
													font-style : {block.content[index].textFontStyle};
													text-decoration: {block.content[index].textFontDeco};
													text-align: {block.content[index].textAlign};
													background-color : {block.content[index].textBackgroundColor};
													margin-top : {block.content[index].textMarginTop}%;
													margin-bottom : {block.content[index].textMarginBottom}%;
													padding : {block.content[index].textPadding}%;
													user-select: text;
													white-space:pre-wrap;
													"
												>
													{block.content[key].text}
												</div>
											{/if}
										</div>
									{/if}
								</div>
							{/each}
						</div>
					</div>
				{/if}
			{/if}
		{/each}
	{/if}
</IntersectionObserver>

<style>
	article {
		color: var(--linkColor);
	}
	article:hover {
		color: var(--linkHover);
	}

	.link_row {
		height: 100%;
		font-size: var(--fsXS);
		display: flex;
		align-items: center;
	}

	[data-padding] {
		padding: 30px;
	}

	.link,
	.link_title {
		height: 100%;
		margin-left: 20px;
	}

	.link {
		color: blue;
		cursor: pointer;
	}

	.link:hover {
		color: red;
	}

	.link_title {
		color: green;
	}

	.column_container {
		display: flex;
		flex-direction: column;
	}

	.column_row {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		grid-gap: var(--gridGap);
	}

	.image_container {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
	}

	.col_image {
		width: 100%;
		object-fit: cover;
	}

	[data-imagehover]:hover {
		filter: brightness(120%);
	}

	.column_tool_bar_container {
		display: flex;
		justify-content: space-around;
		align-items: center;
		background-color: hsl(0, 0%, 70%);
		min-height: 40px;
	}

	.column_tool_link {
		font-size: var(--fsN);
		cursor: pointer;
	}

	.column_tool_link:hover {
		color: blue;
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}

	[data-link] {
		display: flex;
		justify-content: center;
		width: 100%;
		margin-bottom: 20px;
	}

	.linked_site {
		color: var(--colorError);
		font-size: var(--fsN);
		font-weight: bold;
		margin-left: 20px;
		text-transform: uppercase;
	}
</style>
